module.exports = __webpack_public_path__ + "static/media/logo_sm.543438a9.png";